{
  "en-GB": {
    "model": {
      "profile": {
        "id": "User ID",
        "userName": "Username",
        "email": "Email address",
        "emailConfirmed": "Email confirmed",
        "phoneNumber": "Phone number",
        "phoneNumberConfirmed": "Phone number confirmed",
        "twoFactorEnabled": "Two-factor authentication enabled",
        "lockoutEnd": "Lockout end",
        "lockoutEnabled": "Lockout enabled",
        "accessFailedCount": "Access failed count",
        "firstName": "First name",
        "lastName": "Last name",
        "picture": "Avatar picture",
        "organisationName": "Organisation",
        "name": "Name",
        "roles": "Roles"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Confirmed"
      },
      "action": {
        "resetPassword.tooltip": "Send password reset instructions to the user by email."
      },
      "message": {
        "resetPassword.success": "An email has been sent to the user with instructions to reset their password."
      }
    }
  }
}